import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import useModal from 'components/common/Modal/useModal';
import { ModalComponentGenerator, ModalComponentType } from 'components/common/Modal/ModalComponentGenerator';
import { LOGIN_POPUP } from "constants/loginTypes";
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import { ReaderToolType } from 'constants/ReaderTools';
import { useGAEvent } from 'components/AppService/GAService';
// import { PainterMode } from 'constants/painterModes';

export const useAnswerInteractiveToolCommand = () => {
    const { gaEvent } = useGAEvent();
    const [, { openModal, setModalComponents }] = useModal();
    const [, loginDispatch] = useStore(StoreTypes.login);
    const [{token}] = useStore(StoreTypes.user);

    // const changePainterMode = ({ event, painterMode, painterToolType }) => {
    //     EventBus.emit({ event, payload: { painterMode, painterToolType } });
    // };

    const setReaderToolType = type => {
        EventBus.emit({
            event: ReaderToolsEvent.SetReaderToolTypeEvent,
            payload: {
                readerToolType: type
            }
        });
    }

    const execute = useCallback(async ({ canvasSVGObject }) => {
        gaEvent('工具列_快問快答');
        if(!token){
            loginDispatch({ type: LOGIN_POPUP, popupState: true });
            return;
        }

        try {
            const component = ModalComponentGenerator.generate(ModalComponentType.AnswerInteractiveTool, { canvasSVGObject });
            setModalComponents(component);
            setReaderToolType(ReaderToolType.AnswerInteractiveTool);

            // changePainterMode({
            //     event: ReaderToolsEvent.ClickSelectEvent,
            //     painterMode: PainterMode.Selection
            // });

            openModal();
        } catch (e) {
            console.error('AnswerInteractiveTool execute error', e);
        }
    }, [loginDispatch, openModal, setModalComponents, token, gaEvent]);

    return { execute };
};
